    <div class="table-responsive">

<div class="">
  <div class="card-body">
    <!-- Barre de recherche -->
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="actesFilter"
        placeholder="🔍 Rechercher un acte..."
      />
    </div>

      <table class="table table-hover table-center">
        <thead>
          <tr>
            <th>ACTE</th>
            <th *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId" >PRIX MÉDECIN</th>
            <th *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId">PRIX CLINIQUE</th>
            <th>MONTANT</th>
            <th>NOTE</th>
            <th>ACTION</th>
          </tr>
        </thead>
      <tbody>
  <ng-container *ngFor="let group of groupedActesByFamily">

    <!-- 🔹 Ligne groupe -->
    <tr class="table-group-header" (click)="toggleGroup(group.familyName)">
      <td colspan="6">
        <div class="d-flex justify-content-between align-items-center">
          <div class="fw-bold text-primary d-flex align-items-center gap-2">
            <i
              class="bi"
              [ngClass]="{
                'feather-plus': isGroupExpanded(group.familyName),
                'feather-minus': !isGroupExpanded(group.familyName)
              }"
            ></i>
            {{ group.familyName }}
          </div>

          <!-- Tout sélectionner -->
          <div
            class="form-check form-switch"
            (click)="$event.stopPropagation()"
          >
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="isAllActesInFamilySelected(group.familyName)"
              (change)="toggleAllActesInFamily(group.familyName, $event)"
            />
            <label class="form-check-label">Tout sélectionner</label>
          </div>
        </div>
      </td>
    </tr>

    <!-- 🔹 Actes du groupe (affichés seulement si ouvert) -->
    <ng-container *ngIf="isGroupExpanded(group.familyName)">
      <tr
        *ngFor="let act of group.actes | filterAct : actesFilter"
        [class.table-success]="isActeSelected(act)"
      >
        <td>
          <div class="fw-bold">{{ act.actes?.desc_Acte }}</div>
          <small class="text-danger" *ngIf="doctor.speciality.label !=='Ophtalmologue'">
            {{ act.actes?.cnam_ACT_COD || '----' }}
          </small>
        </td>

    

        <td *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="actesDoctor[act.actes?.id_Acte]"
            (input)="updateDoctorPrice(act, $event)"
          />
        </td>

        <td *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="actesClinique[act.actes?.id_Acte]"
            (input)="updateClinicPrice(act, $event)"
          />
        </td>
    <td >
          <input
            type="number"
            class="form-control"
            [(ngModel)]="actesTotal[act.actes?.id_Acte]"
            (input)="updateMontant(act, $event)"
          />
        </td>
        <td>
          <textarea
            class="form-control"
            [(ngModel)]="actesNotes[act.actes?.id_Acte]"
            (blur)="onNoteBlur(act)"
          ></textarea>
        </td>

        <td>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="isActeSelected(act)"
              (change)="toggleActeForConsultation(act, $event)"
            />
          </div>
        </td>
      </tr>
    </ng-container>

  </ng-container>
</tbody>

      </table>
    </div>
  </div>
</div>